var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "p",
    { staticClass: "well" },
    [
      _c("el-switch", {
        staticClass: "fright",
        attrs: { value: _vm.enabled, "active-color": "#13ce66" },
        on: {
          change: function(state) {
            return this$1.$emit("update:enabled", state)
          }
        }
      }),
      _vm._v(" "),
      _c("span", { staticClass: "grey fright mt-1 mr-1 fs-3" }, [
        _vm._v("\n        " + _vm._s(_vm.enableText) + "\n    ")
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "semibold fs-3" }, [
        _vm._v(_vm._s(_vm.description))
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }